
// You can write more code here

/* START OF COMPILED CODE */

import ChunkBase from "../../ChunkBase";
import ChunkBoundaries from "../../../components/ChunkBoundaries";
import BoundsMarker from "../../editor/BoundsMarker";
import DecorationTrunk from "../../decorations/jungle/DecorationTrunk";
import PlatformMarkerFoliage3 from "../../editor/platform-markers/jungle/PlatformMarkerFoliage3";
import SmallGemMarker from "../../editor/entity-markers/SmallGemMarker";
import PlatformMarkerFoliage4 from "../../editor/platform-markers/jungle/PlatformMarkerFoliage4";
import PlatformFoliage1 from "../../platforms/jungle/PlatformFoliage1";
import PlatformFoliage2 from "../../platforms/jungle/PlatformFoliage2";
import MegaGemMarker from "../../editor/entity-markers/MegaGemMarker";
import TrapMarkerSpikes from "../../editor/trap-markers/jungle/TrapMarkerSpikes";
import PositionMarker from "../../editor/PositionMarker";
import PlatformMarkerJungleLog from "../../editor/platform-markers/jungle/PlatformMarkerJungleLog";
import MoverData from "../../../components/platformer/MoverData";
import CheckpointMarker from "../../editor/CheckpointMarker";
/* START-USER-IMPORTS */
/* END-USER-IMPORTS */

export default class JungleChunkEasy3 extends ChunkBase {

  constructor(scene: Phaser.Scene, x?: number, y?: number) {
    super(scene, x ?? 341, y ?? 108);

    // editor_bounds_right
    const editor_bounds_right = new BoundsMarker(scene, 4941, 661);
    this.add(editor_bounds_right);

    // editor_bounds_left
    const editor_bounds_left = new BoundsMarker(scene, -331, 661);
    this.add(editor_bounds_left);

    // trunk_png_1
    const trunk_png_1 = new DecorationTrunk(scene, 1119, 663);
    this.add(trunk_png_1);

    // trunk_png_2
    const trunk_png_2 = new DecorationTrunk(scene, -137, 805);
    this.add(trunk_png_2);

    // trunk_png
    const trunk_png = new DecorationTrunk(scene, 425, 655);
    this.add(trunk_png);

    // platformMarkerFoliage
    const platformMarkerFoliage = new PlatformMarkerFoliage3(scene, -141, 503);
    this.add(platformMarkerFoliage);

    // platformMarkerFoliage_1
    const platformMarkerFoliage_1 = new PlatformMarkerFoliage3(scene, 1116, 360);
    this.add(platformMarkerFoliage_1);

    // gemMarker_11
    const gemMarker_11 = new SmallGemMarker(scene, 3286, -304);
    this.add(gemMarker_11);

    // platformMarkerFoliage4
    const platformMarkerFoliage4 = new PlatformMarkerFoliage4(scene, 2197, -150);
    this.add(platformMarkerFoliage4);

    // platformFoliage1
    const platformFoliage1 = new PlatformFoliage1(scene, 2871, -212);
    this.add(platformFoliage1);

    // platformFoliage2
    const platformFoliage2 = new PlatformFoliage2(scene, 429, 350);
    this.add(platformFoliage2);

    // platformFoliage
    const platformFoliage = new PlatformFoliage1(scene, 1570, 85);
    this.add(platformFoliage);

    // trunk_png_4
    const trunk_png_4 = new DecorationTrunk(scene, 761, 591);
    this.add(trunk_png_4);

    // trunk_png_5
    const trunk_png_5 = new DecorationTrunk(scene, 1720, 841);
    this.add(trunk_png_5);

    // platformFoliage_2
    const platformFoliage_2 = new PlatformFoliage1(scene, 2487, 440);
    this.add(platformFoliage_2);

    // trunk_png_6
    const trunk_png_6 = new DecorationTrunk(scene, 2491, 745);
    this.add(trunk_png_6);

    // platformFoliage_4
    const platformFoliage_4 = new PlatformFoliage1(scene, 769, 286);
    this.add(platformFoliage_4);

    // gemMarker
    const gemMarker = new SmallGemMarker(scene, 1991, -259);
    this.add(gemMarker);

    // gemMarker_1
    const gemMarker_1 = new SmallGemMarker(scene, 1724, 413);
    this.add(gemMarker_1);

    // gemMarker_2
    const gemMarker_2 = new SmallGemMarker(scene, 1117, 257);
    this.add(gemMarker_2);

    // gemMarker_3
    const gemMarker_3 = new SmallGemMarker(scene, 1573, 4);
    this.add(gemMarker_3);

    // gemMarker_4
    const gemMarker_4 = new SmallGemMarker(scene, 431, 254);
    this.add(gemMarker_4);

    // gemMarker_5
    const gemMarker_5 = new SmallGemMarker(scene, 2495, 342);
    this.add(gemMarker_5);

    // gemMarker_6
    const gemMarker_6 = new SmallGemMarker(scene, 3821, 398);
    this.add(gemMarker_6);

    // megaGemMarker
    const megaGemMarker = new MegaGemMarker(scene, 3466, -288);
    this.add(megaGemMarker);

    // platformMarkerFoliage_5
    const platformMarkerFoliage_5 = new PlatformMarkerFoliage3(scene, 4462, 290);
    this.add(platformMarkerFoliage_5);

    // trunk_png_8
    const trunk_png_8 = new DecorationTrunk(scene, 4450, 592);
    this.add(trunk_png_8);

    // gemMarker_7
    const gemMarker_7 = new SmallGemMarker(scene, 4454, 197);
    this.add(gemMarker_7);

    // platformMarkerFoliage_6
    const platformMarkerFoliage_6 = new PlatformMarkerFoliage4(scene, 1727, 530);
    this.add(platformMarkerFoliage_6);

    // trapSpikesMarker_2
    const trapSpikesMarker_2 = new TrapMarkerSpikes(scene, 3645, -262);
    this.add(trapSpikesMarker_2);

    // platformMarkerFoliage_7
    const platformMarkerFoliage_7 = new PlatformMarkerFoliage4(scene, 3474, -192);
    this.add(platformMarkerFoliage_7);

    // trunk_png_9
    const trunk_png_9 = new DecorationTrunk(scene, 3170, 787);
    this.add(trunk_png_9);

    // platformFoliage_1
    const platformFoliage_1 = new PlatformFoliage2(scene, 3174, 480);
    this.add(platformFoliage_1);

    // gemMarker_8
    const gemMarker_8 = new SmallGemMarker(scene, 2872, -311);
    this.add(gemMarker_8);

    // positionMarker
    const positionMarker = new PositionMarker(scene, 3657, 468);
    this.add(positionMarker);

    // positionMarker_1
    const positionMarker_1 = new PositionMarker(scene, 3996, 471);
    this.add(positionMarker_1);

    // platformFoliage_3
    const platformFoliage_3 = new PlatformFoliage1(scene, 4086, -72);
    this.add(platformFoliage_3);

    // platformMarkerJungleLog
    const platformMarkerJungleLog = new PlatformMarkerJungleLog(scene, 3662, 468);
    this.add(platformMarkerJungleLog);

    // megaGemMarker_1
    const megaGemMarker_1 = new MegaGemMarker(scene, 3184, 416);
    this.add(megaGemMarker_1);

    // gemMarker_9
    const gemMarker_9 = new SmallGemMarker(scene, 3913, 396);
    this.add(gemMarker_9);

    // gemMarker_10
    const gemMarker_10 = new SmallGemMarker(scene, 3730, 396);
    this.add(gemMarker_10);

    // gemMarker_12
    const gemMarker_12 = new SmallGemMarker(scene, 4094, -159);
    this.add(gemMarker_12);

    // checkpointMarker
    const checkpointMarker = new CheckpointMarker(scene, -239, 463);
    this.add(checkpointMarker);

    // checkpointMarker_1
    const checkpointMarker_1 = new CheckpointMarker(scene, 1556, 458);
    this.add(checkpointMarker_1);

    // gemMarker_13
    const gemMarker_13 = new SmallGemMarker(scene, 2190, -266);
    this.add(gemMarker_13);

    // this (components)
    new ChunkBoundaries(this);

    // platformMarkerJungleLog (components)
    const platformMarkerJungleLogMoverData = new MoverData(platformMarkerJungleLog);
    platformMarkerJungleLogMoverData.startMarker = positionMarker;
    platformMarkerJungleLogMoverData.endMarker = positionMarker_1;
    platformMarkerJungleLogMoverData.startWait = 500;
    // awake handler
    this.scene.events.once("scene-awake", () => this.awake());

    /* START-USER-CTR-CODE */
    // Write your code here.
    /* END-USER-CTR-CODE */
  }

  /* START-USER-CODE */

  // Write your code here.

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
